import { CartService } from "./cart"
import { initIcons } from "../icons"

function log(message: string) {
    console.log(`[CART]: ${message}`)
}

export function initCartUI(selector = ".add-to-cart-btn,#addToCartBtn") {

    document.querySelectorAll<HTMLElement>(selector).forEach(btn => {

        const label = btn.querySelector<HTMLElement>(".btn-label")
        const spinner = btn.querySelector<HTMLElement>(".btn-spinner")
        const isIconOnly = btn.dataset.iconOnly === "true"
        const initialLabelHtml = label?.innerHTML ?? ""
        const initialAriaLabel = btn.getAttribute("aria-label")

        const MIN_LOADING = 300

        const setIconOnlyAriaLabel = (value: string | null) => {
            if (!isIconOnly) return

            if (value) {
                btn.setAttribute("aria-label", value)
                return
            }

            btn.removeAttribute("aria-label")
        }

        const setLoading = () => {
            btn.classList.add("is-disabled", "is-loading", "pointer-events-none", "brightness-90")

            if (label) label.classList.add("hidden")
            if (spinner) spinner.classList.remove("hidden")
        }

        const setSuccess = () => {
            if (spinner) spinner.classList.add("hidden")

            if (label) {
                label.classList.remove("hidden")
                label.innerHTML = isIconOnly
                    ? `<i data-lucide="check" class="h-4 w-4"></i>`
                    : `
                        <i data-lucide="check" class="h-4 w-4"></i>
                        <span class="text">Added</span>
                    `
                initIcons()
            }

            setIconOnlyAriaLabel("Added to cart")

            // keep permanently disabled
            btn.classList.add("is-disabled", "pointer-events-none", "brightness-90")
        }

        const handleClick = async (e: Event) => {
            e.preventDefault()
            e.stopPropagation()

            const sku = btn.dataset.sku

            if (!sku || btn.classList.contains("is-disabled")) return

            log("TRYING TO ADD TO CART")

            setLoading()

            const start = performance.now()

            try {
                await CartService.add(sku, 1)

                const elapsed = performance.now() - start
                const remaining = Math.max(MIN_LOADING - elapsed, 0)

                setTimeout(() => {
                    setSuccess()
                }, remaining)

            } catch {
                // fallback: reset to idle visually (rare case)
                btn.classList.remove("is-disabled", "is-loading", "pointer-events-none", "brightness-90")

                if (spinner) spinner.classList.add("hidden")

                if (label) {
                    label.classList.remove("hidden")
                    label.innerHTML = initialLabelHtml
                    initIcons()
                }

                setIconOnlyAriaLabel(initialAriaLabel)
            }
        }

        btn.addEventListener("click", handleClick)

        btn.addEventListener("keydown", e => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                handleClick(e)
            }
        })
    })

    const update = () => {
        const count = CartService.count()

        document.querySelectorAll(".cart-count")
            .forEach(x => x.textContent = count.toString())

        document.querySelectorAll(".cart-items-label")
            .forEach(x => x.textContent = count === 1 ? "item" : "items")

        const wrap = document.getElementById("cartWidgetContainer")
        if (wrap) wrap.style.display = count > 0 ? "block" : "none"

        const mobileCart = document.getElementById("mobileNavCart")
        mobileCart?.classList.toggle("hidden", count <= 0)

        const mobileHeaderBadge = document.getElementById("mobileHeaderCartBadge")
        mobileHeaderBadge?.classList.toggle("hidden", count <= 0)

        const mobileHeaderCart = document.getElementById("mobileHeaderCart")
        mobileHeaderCart?.setAttribute("aria-label", count > 0
            ? `View cart, ${count} ${count === 1 ? "item" : "items"}`
            : "View cart")
    }

    update()
    window.addEventListener("cart:changed", update)
}
